import axiosClient from 'api/config/axiosClient';
import { isNull } from 'lodash';

export const getPartnerAccountAccessRanking = ({
  pageNumber,
  pageSize,
  dateFrom,
  dateTo,
  filterId,
}) => {
  const url = `v1/logging/ranking/page-access/by-partner?pageNumber=${pageNumber}&pageSize=${pageSize}&dateFrom=${dateFrom}&dateTo=${dateTo}&filterId=${isNull(filterId) ? '' : filterId}`;
  return axiosClient.get(url, { timeout: 0 });
};

export const getPartnerFileDownloadRanking = ({
  pageNumber,
  pageSize,
  dateFrom,
  dateTo,
  filterId,
}) => {
  const url = `v1/logging/ranking/file-download/by-partner?pageNumber=${pageNumber}&pageSize=${pageSize}&dateFrom=${dateFrom}&dateTo=${dateTo}&filterId=${isNull(filterId) ? '' : filterId}`;
  return axiosClient.get(url, { timeout: 0 });
};

export const getLoginCount = ({ dateFrom, dateTo, id, email }) => {
  const url = `v1/logging/login-count?dateFrom=${dateFrom}&dateTo=${dateTo}${!isNull(id) && !email ? `&id=${id}` : ``}${email && !id ? `&email=${email}` : ``}`;
  return axiosClient.get(url, { timeout: 0 });
};

export const getPartners = ({ keyword }) => {
  const url = `v1/partner/logs${keyword ? `?keyword=${keyword}` : ''}`;
  return axiosClient.get(url, { timeout: 0 });
};
